import React from "react";
import "./patientFullView.css";
import { useTranslation } from "react-i18next";

const PatientAddressView = ({ address }) => {
  const { t } = useTranslation();
  const getField = (field) => (field ? t(field) : `${t("--NA--")}`);
  return (
    <div className="pav-container">
      <div className="pav-add-item">
        <div className="pav-add-header">
          <section>
            {/* <div className={`pav-checkbox ${address.selected ? "selected" : ""}`}>
                  <div className="pav-dot"></div>
                </div> */}
            <p>{t("address")}</p>
          </section>
          {/* <span className={`pav-status ${getField(address?.isVerified)}`}>{getField(address?.isVerified)}</span> */}
        </div>
        <div className="pav-add-details">
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("phoneNumber")}</p>
            <p className="pdl-number">{getField(address?.personalCountryCode) + " " + address?.personalPhoneNumber}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("officeNumber")}</p>
            <p className="pdl-number">{address?.officePhoneNumber ? address?.officeCountryCode + address?.officePhoneNumber : t("--NA--")}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("street")}</p>
            <p className="pdl-number">{getField(address?.street)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("ward")}</p>
            <p className="pdl-number">{getField(address?.ward)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("district")}</p>
            <p className="pdl-number">{getField(address?.district)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("city")}</p>
            <p className="pdl-number">{getField(address?.city)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("province")}</p>
            <p className="pdl-number">{getField(address?.province)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("postalCode")}</p>
            <p className="pdl-number">{getField(address?.postalCode)}</p>
          </div>
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("addTag")}</p>
            <p className="pdl-number">{getField(address?.saveAs)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAddressView;
